import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

export default function ForgotPassword() {
  const [input, setInput] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen w-full bg-white">
      <div className="bg-[#F47B6C] p-6 pb-12">
        <div className="flex items-center justify-between mb-6">
          <button onClick={() => navigate(-1)} className="p-2">
            <ChevronLeftIcon className="h-6 w-6 text-white" />
          </button>
          <h1 className="text-xl font-bold text-white">Bounty Game</h1>
          <div></div>
        </div>
        <div className="mb-4">
          <h1 className="text-2xl font-bold mb-2 text-white">Forgot Password</h1>
          <p className="text-white/80 text-sm">Enter your phone number or email to reset your password.</p>
        </div>
      </div>
      <div className="bg-white -mt-6 rounded-t-[2rem] p-6 min-h-[calc(100vh-16rem)] shadow-sm">
        {submitted ? (
          <div className="text-center mt-12">
            <p className="text-lg text-gray-700 font-semibold mb-4">Password reset is not available online.</p>
            <p className="text-gray-500 mb-2">Please contact customer service to reset your password.</p>
            <p className="text-gray-700 font-medium">Email: <a href="mailto:support@bountygame.com" className="text-[#F47B6C] underline">support@bountygame.com</a></p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6 max-w-md mx-auto mt-8">
            <div className="space-y-2">
              <label className="flex items-center gap-2">
                <PhoneIcon className="h-5 w-5 text-[#F47B6C]" />
                <EnvelopeIcon className="h-5 w-5 text-[#F47B6C]" />
                <span className="text-base text-gray-700">Phone or Email</span>
              </label>
              <input
                type="text"
                placeholder="Enter phone number or email"
                className="bg-gray-50 rounded-xl px-4 py-3 w-full text-gray-700 placeholder-gray-400 border border-gray-200"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-[#F47B6C] text-white rounded-full py-3.5 text-base font-medium mt-6"
            >
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  );
} 